import { CompanysitesService, CompanySite } from './../company-sites.service';
import { Component, ElementRef, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { CardLink } from 'src/app/layout/card-view-layout/card-view-simple-card/card-view-simple-card.component';
import { combineLatest, Observable, Subject } from 'rxjs';
import { CommonPopup } from '../../common-popup/common-popup';
import { MatDialog as MatDialog } from '@angular/material/dialog';
import { NgForm } from '@angular/forms';
import { DialogDelete } from 'src/app/dialog-delete/dialog-delete.component';
import { map, startWith } from 'rxjs/operators';
import { AuthService } from 'src/app/services/auth.service';
import { User } from 'src/app/auth/user';
import { QueryDocumentSnapshot, QuerySnapshot } from 'firebase/firestore';
import { BreakpointObserver } from '@angular/cdk/layout';
import { DocumentChangeAction } from '@angular/fire/compat/firestore';
import { ConfigService } from 'src/app/shared/config';
import mqtt from 'mqtt/dist/mqtt';
// import { EventEmitter } from 'stream';
// import moment from  'moment-timezone/builds/moment-timezone-with-data-1970-2030.min.js';

@Component({
  selector: 'app-company-sites-list',
  templateUrl: './company-sites-list.component.html',
  styleUrls: ['./company-sites-list.component.css']
})

export class CompanySitesListComponent implements OnInit, OnDestroy {

  filter$: Subject<string>;
  value: string = "";
  testLinks: CardLink[];
  sites$: Subject<CompanySite[]> = new Subject();
  filterdSites$: Observable<CompanySite[]>;
  filterdSystems$: Observable<any[]>;
  actionButtons = [];
  actionButtonsSystems = [];
  user: User
  user$: Observable<User>;
  tabIndex: number = 0;

  userSubscription: any;
  userServiceSubscription: any;
  systemSubscription: any;

  systemState: any = {};

  mqttClient: any;

  isSupport: boolean = false;

  testEvent;

  systems = [];
  systems$: Subject<any[]> = new Subject();
  systemStatus$: Observable<any>;
  alertManagerInterval: any;
  mqttClientId = Math.random().toString(16).substr(2, 8); 

  summaryStatusSubscription: any;
  siteSystemSubscription: any;
  userSiteSubscription: any;
  systemsSubscription: any;
  handsetSubscription: any;
  dialogCloseSubscription: any;
  onCloseSubscription: any;
  systemStatusSubscription: any;

  alarms = [
    // { type: 'warning', message: 'Low battery on Site A' },
    // { type: 'fault', message: 'Connection lost on Site B' },
    // { type: 'warning', message: 'Low battery on Site A' },
    // { type: 'fault', message: 'Connection lost on Site B' },
    // { type: 'warning', message: 'Low battery on Site A' },
    // { type: 'fault', message: 'Connection lost on Site B' },
    // { type: 'warning', message: 'Low battery on Site A' },
    // { type: 'fault', message: 'Connection lost on Site B' }
    // Add more alarms dynamically as needed
  ];

  isHandset$: Observable<boolean> = this.breakpointObserver.observe(['(max-width: 960px)'])
    .pipe(
      map(result => result.matches)
    );
  isMobile: boolean = false;


  @ViewChild('seachField') seachField!: ElementRef

  constructor(
    private sitesService: CompanysitesService,
    public dialog: MatDialog,
    public auth: AuthService,
    private breakpointObserver: BreakpointObserver,
    private config: ConfigService
  ) {

    this.user$ = this.auth.user$;



    this.userSubscription = this.user$.subscribe(user => {
      this.user = user

      const siteIds = user['sites']

      this.userSiteSubscription = this.sitesService.getCompanySites$().subscribe((querySnapshot: QueryDocumentSnapshot[]) => {
        const sites = querySnapshot.reduce((acc, doc) => {

          if (siteIds.includes(doc.id)) {
            acc.push({
              ...doc.data(),
              name: doc.data()['name'],
              siteId: doc.id,
              location: doc.data()['location'],
              uid: doc.id,
              url: '/dashboard/sites/' + doc.id
            })
          }
          return acc;
        }, []);

        this.sites$.next(sites);
      });

      this.systemStatus$ = this.sitesService.getComanySystemsStatus$().pipe(startWith([]));




      this.systemsSubscription = this.sitesService.getCompanySystems$().subscribe((querySnapshot: QueryDocumentSnapshot[]) => {
        this.systems = querySnapshot.map(doc => {

          const data = doc.data();

          return {
            ...data,
            name: data['name'].replaceAll("_", " "),
            url: `/dashboard/sites/` + data['siteId'] + "/system/" + data['systemId'] + "/overview"
          } as any
        });

        this.systemStatusSubscription = this.systemStatus$.subscribe((snapshot: DocumentChangeAction<unknown>[]) => {

          snapshot.map((doc) => {
            if (doc.type == "added" || doc.type == "modified") {

              const data = doc.payload.doc.data();
              const id = doc.payload.doc.id;

              // Find system with id
              const system = this.systems.find(system => system.systemId == id);

              if (!system) return;
              system.status = data;

              // system.name = data['ping'].status ? "PING" : "NO PING";
            }
          })

        })
        this.startUpdateFromAlertManager();
        this.systems$.next(this.systems);
      });
    })

    this.userServiceSubscription = this.auth.user$.subscribe(async user => {

      this.isSupport = user['support'] || false;

      if (!this.isSupport) {
        return;
      }

      const token = await this.auth.getToken();

      this.mqttClient = mqtt.connect('wss://prod1.friggkantine.no:9091/?token=' + token,
        {
          keepalive: 30,
          clientId: 'frigg-admin-site-list-' + this.mqttClientId,
        }
      );

      this.mqttClient.on('connect', () => {
        console.log('Connected to MQTT broker');
        this.summaryStatusSubscription = this.mqttClient?.subscribe(`summary/systems/status/#`, (err) => {
          if (!err) {
            console.log('Subscribed to topic: summary/systems/status/#');
          }
        });
      })

      this.mqttClient.on('message', (topic, message) => {


        try {
          this.systemState = JSON.parse(message.toString());

          const newAlarmList = this.alarms.filter(a => a.source !== 'mqtt');

          Object.keys(this.systemState.systems).forEach(systemNumber => {

            const system = this.systemState.systems[systemNumber];

            if (system.openDoors && system.openDoors.length > 0) {
              system.openDoors.forEach(node => {
                newAlarmList.push({ type: 'warning', message: `${systemNumber}: Door ${node} is open`, systemNumber: systemNumber, source: 'mqtt', alarmTitle: system.name, systemId: system.systemId });
              });
            }


          });

          this.alarms = newAlarmList;

        } catch (e) {
          console.error("Invalid JSON payload:", message.toString());
          return;
        }
      });
    });

    this.actionButtons.push({ icon: 'person', tooltip: 'Show employees', relativeUrl: 'membership-test' })
    this.actionButtons.push({ icon: 'description', tooltip: 'Show projects', relativeUrl: 'project' })
    this.actionButtons.push({ icon: 'format_list_bulleted', tooltip: 'Show reports', relativeUrl: 'report' })
    this.actionButtonsSystems.push({ icon: 'format_list_bulleted', tooltip: 'Show reports' })


    this.systemSubscription = this.systems$.subscribe(systems => {

      const newAlarmList = this.alarms.filter(a => a.source !== 'systems');

      systems.filter(system => system.windowMessage !== "" && system.windowMessage !== undefined).forEach(system => {

        if (system.windowMessage.length > 5) {
          newAlarmList.push({ type: system.popupType || 'warning', message: `${system.number}: Warning message active in app!`, systemNumber: system.number, alarmTitle: system.name, source: 'systems' });
        } else {
          // Remove existing warning for this system
          const index = newAlarmList.findIndex(a => a.systemNumber === system.number && a.source === 'systems');
          if (index !== -1) {
            newAlarmList.splice(index, 1);
          }
        }

      });

      this.alarms = newAlarmList;

    });

    this.siteSystemSubscription = combineLatest([this.sites$, this.systems$])
      .subscribe(([sites, systems]) => {

        // Add site information to systems

        this.systems.forEach(system => {

          const siteId = system.siteId;
          // Find site info
          const site = sites.find(site => site['uid'] == siteId);

          if (site) {
            system.siteInfo = site;
            if (site.name.toLocaleLowerCase() !== system.name.toLocaleLowerCase())
              system.location = site.location + " - " + site.name;
            else
              system.location = site.location;
          }

        })

      })

    this.handsetSubscription = this.isHandset$.subscribe(result => {
      this.isMobile = result;
    });



    // Get tab index from local storage
    if (localStorage.getItem("siteTabIndex"))
      this.tabIndex = Number(localStorage.getItem("siteTabIndex"));
    else
      this.tabIndex = 0;

  }

  startUpdateFromAlertManager() {

    const fetchAlertsFromAlertManager = async () => {
      const token = await this.auth.getToken();
      // console.log('token', token);
      const url = `https://main.friggkantine.no/service/alertmanager/api/v2/alerts?token=${token}`;

      // console.log('Fetching alerts from Alert Manager...');
      const response = await fetch(url);
      const data = await response.json();

      if (data && Array.isArray(data)) {
        // Clear existing alert alarms from this source
        const newAlarmList = this.alarms.filter(a => a.source !== 'alertmanager');

        // Process the alert data
        await Promise.all(data.filter(alert => alert.status.state === 'active').map(async alert => {

          if (alert.labels['alertname'] === 'SystemDown') {
            return;
          }

          if (alert.labels['type'] === 'system') {

            const systemNumber = alert.labels['system'];

            let system = this.systems.find(s => s.number == systemNumber);

            if (!system) {
              // Try to get from database
              console.log('System not found in list, trying to fetch from database:', systemNumber);
              system = await this.sitesService.getSystemByNumber(Number(systemNumber))
            }

            if (!system) {
              console.log('System not found in database:', systemNumber);
              return;
            }

            // console.log('system', system);
            // newAlarmList.push({ type: 'fault', message: `${systemNumber}: Connection lost`, systemNumber: systemNumber, source: 'mqtt', systemName: system.name, systemId: system.systemId });
            newAlarmList.push({ type: 'fault', message: `${systemNumber}: ${alert.annotations.summary}`, tooltip: alert.annotations.description, source: 'alertmanager', systemNumber: systemNumber, alarmTitle: system.name, systemId: system.systemId });
          } else {
            // General alert not tied to a system
            newAlarmList.push({ type: 'fault', message: `${alert.annotations.summary}`, alarmTitle: `General Alert`, tooltip: alert.annotations.description, source: 'alertmanager', blinking: true });

          }
        }

        ));

        console.log('newAlarmList', newAlarmList);
        // console.log('currentAlarms', this.alarms);

        // If there is any change in alarms, update the list
        if (JSON.stringify(this.alarms) !== JSON.stringify(newAlarmList)) {
          this.alarms = newAlarmList;
        }
      }

      console.log('Alert data:', data);
    };

    this.alertManagerInterval = setInterval(() => {
      fetchAlertsFromAlertManager();
    }, 60 * 1000); // every minute

    fetchAlertsFromAlertManager();
  }

  ngOnDestroy(): void {
    if (this.userSubscription) {
      this.userSubscription.unsubscribe();
    }

    if (this.userServiceSubscription) {
      this.userServiceSubscription.unsubscribe();
    }

    if (this.systemSubscription) {
      this.systemSubscription.unsubscribe();
    }

    if (this.alertManagerInterval) {
      clearInterval(this.alertManagerInterval);
    }
    if (this.userSiteSubscription) {
      this.userSiteSubscription.unsubscribe();
    }

    if (this.systemsSubscription) {
      this.systemsSubscription.unsubscribe();
    }

    if (this.handsetSubscription) {
      this.handsetSubscription.unsubscribe();
    }

    if (this.dialogCloseSubscription) {
      this.dialogCloseSubscription.unsubscribe();
    }

    if (this.onCloseSubscription) {
      this.onCloseSubscription.unsubscribe();
    }

    if (this.systemStatusSubscription) {
      this.systemStatusSubscription.unsubscribe();
    }
  }

  getNameFromNumber(systemNumber) {
    const system = this.systems.find(s => s.number == systemNumber);
    return system ? system.name : '';
  }

  goToServicePopupForSystem(systemId) {

    window.open(`/support/shell/${systemId}`, '_blank', 'width=1250,height=800,location=no,menubar=no,toolbar=no');
  }




  ngOnInit(): void {

    this.filter$ = new Subject<string>();

    this.value = localStorage.getItem("siteFilter") || "";

    this.filterdSites$ = combineLatest([this.sites$, this.filter$.pipe(startWith(this.value))]).pipe(
      map(([sites, filterString]) => {
        return sites.filter(site => {
          return site.name.toLowerCase().includes(filterString.toLowerCase()) || site.location.toLowerCase().includes(filterString.toLowerCase());
        });
      })
    );

    this.filterdSystems$ = combineLatest([this.systems$, this.filter$.pipe(startWith(this.value))]).pipe(
      map(([systems, filterString]) => {

        // Find systems with errors

        return systems.filter(system => {
          if (system.location) {
            return system.name.toLowerCase().includes(filterString.toLowerCase()) || system.location.toLowerCase().includes(filterString.toLowerCase()) || system.number.toString().toLowerCase().includes(filterString.toLowerCase())
          } else {
            return system.name.toLowerCase().includes(filterString.toLowerCase())
          }
        });
      }),
      map(systems => systems.sort((a, b) => {

        // If Number is less than or equal to 1000, push to end
        if (a.number <= 1000) return 1;
        if (b.number <= 1000) return -1;

        return a.number - b.number;

      }))
    );


  }

  @HostListener('document:keydown.escape', ['$event']) onKeydownHandlerEscape(event: KeyboardEvent) {
    this.value = "";
    this.filter$.next(this.value);
  }


  ngAfterViewInit() {
    if (!this.isMobile) setTimeout(() => this.seachField.nativeElement.focus());
  };

  tabChanged(event) {
    this.tabIndex = event;

    // Save to local storage
    localStorage.setItem("siteTabIndex", event);
  }

  applyFilter(filterValue: string) {

    localStorage.setItem("siteFilter", this.value);

    this.filter$.next(filterValue);
  }

  isCuboid() {
    return this.config.getCompanyId() === 'IbYFkxDI8RbMdRiukALO';
  }

  onAddSite() {
    const dialogRef = this.dialog.open(CommonPopup, {
      disableClose: true,
      width: '500px',
      data: {
        text: "",
        formData: {
          title: "Add Site",
          inputFeilds: [
            {
              labelName: "Site Name",
              name: "name",
              required: true,
              type: "text",
              specialText: ""
            },
            {
              labelName: "Location/Point",
              name: "location",
              required: true,
              type: "text",
              specialText: ""
            }

            // {
            //   labelName: "Keyboard",
            //   name: "isKeyboardActive",
            //   required: true,
            //   type: null,
            //   specialText: "",
            //   selectOptions: [
            //     {
            //       label: "Yes",
            //       value: true
            //     },
            //     {
            //       label: "No",
            //       value: false
            //     }
            //   ]
            // }
          ],
          buttons: [
            {
              name: "ADD",
              type: "submit",
              color: "primary",
              validate: true
            }
          ]
        }
      }
    });

    // 2 No need to unsubscribe from afterClosed() as it auto completes itself.
    this.dialogCloseSubscription = dialogRef.afterClosed().subscribe(async (result: NgForm) => {
      if (result)
        this.sitesService.addSite(result.value);
    });
  }


  async onUpdateSite($event) {
    let event = $event.$event;
    let siteId = $event.uid;

    event.stopPropagation();
    let result = await this.sitesService.getSiteRefById(siteId)
    let obj = result.data();

    if (obj) {

      const existingProjectValue = (() => {
        if (obj['isProjectActive'] && obj['projectNumbersStrict']) return "STRICT";
        else if (obj['isProjectActive']) return "OPEN";
        else return "NO";
      })()
      const dialogRef = this.dialog.open(CommonPopup, {
        disableClose: true,
        width: '500px',
        data: {
          text: "",
          formData: {
            title: `Update Site ${obj['name']}`,
            inputFeilds: [
              {
                labelName: "Name",
                name: "name",
                required: true,
                type: "text",
                value: obj['name'],
                specialText: ""
              },
              {
                labelName: "Location",
                name: "location",
                required: true,
                type: "text",
                value: obj['location'],
                specialText: ""
              }, {
                labelName: "Projects",
                name: "isProjectActive",
                required: true,
                type: null,
                value: existingProjectValue,
                specialText: "",
                selectOptions: [
                  {
                    label: "Yes,open",
                    value: "OPEN"
                  }, {
                    label: "Yes,strict",
                    value: "STRICT"
                  },
                  {
                    label: "No",
                    value: "NO"
                  }
                ]
              },
              {
                labelName: "User Group",
                name: "strictGroup",
                required: true,
                type: null,
                value: obj['strictGroup'] ? obj['strictGroup'] : false,
                specialText: "",
                selectOptions: [
                  {
                    label: "Yes",
                    value: true
                  },
                  {
                    label: "No",
                    value: false
                  }
                ]
              },
              {
                labelName: "Category",
                name: "isCategoryActive",
                required: true,
                type: null,
                value: obj['isCategoryActive'] ? obj['isCategoryActive'] : false,
                specialText: "",
                selectOptions: [
                  {
                    label: "Yes",
                    value: true
                  },
                  {
                    label: "No",
                    value: false
                  }
                ]
              },
              {
                labelName: "Free text",
                name: "isFreetextActive",
                required: true,
                type: null,
                value: obj['isFreetextActive'],
                specialText: "",
                selectOptions: [
                  {
                    label: "Yes",
                    value: true
                  },
                  {
                    label: "No",
                    value: false
                  }
                ]
              },

              // {
              //   labelName: "Keyboard",
              //   name: "isKeyboardActive",
              //   required: true,
              //   type: null,
              //   value: obj['isKeyboardActive'],
              //   specialText: "",
              //   selectOptions: [
              //     {
              //       label: "Yes",
              //       value: true
              //     },
              //     {
              //       label: "No",
              //       value: false
              //     }
              //   ]
              // }
            ],
            buttons: [
              {
                name: "Update",
                type: "submit",
                color: "primary",
                validate: true
              }
            ], // <-- Add comma here
          }
        }
      });



      // 2 No need to unsubscribe from afterClosed() as it auto completes itself.
      this.dialogCloseSubscription = dialogRef.afterClosed().subscribe(async (result: NgForm) => {
        this.sitesService.onUpdateSite(siteId, result.value);
      });
    }
  }

  onDeleteSite($event) {
    let event = $event.$event;
    let siteId = $event.uid;
    event.stopPropagation();

    const dialogRef = this.dialog.open(DialogDelete, {
      disableClose: true,
      width: '350px',
      data: {
        formData: {
          title: "DELETE",
          message: " Are you sure to continue? "
        }
      }
    });

    this.onCloseSubscription = dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.sitesService.onDeleteSite(siteId)
      }
    });

  }

  alarmListOpen = true;

  toggleAlarmList() {
    this.alarmListOpen = !this.alarmListOpen;
  }

  get warningCount(): number {
    return this.alarms.filter(a => a.type === 'warning').length;
  }
  get faultCount(): number {
    return this.alarms.filter(a => a.type === 'fault').length;
  }

  get faultAndWarningsList(): any[] {

    // Sort faults first
    return this.alarms.filter(a => a.type === 'fault' || a.type === 'warning').sort((a, b) => {
      if (a.type === 'fault' && b.type === 'warning') return -1;
      if (a.type === 'warning' && b.type === 'fault') return 1;
      return 0;
    });
  }

  get alarmsSorted() {
    return this.alarms.slice().sort((a, b) => {
      if (a.type === b.type) return 0;
      if (a.type === 'fault') return -1;
      if (b.type === 'fault') return 1;
      return 0;
    });
  }

  getSystemName(systemNumber: number): string {
    const system = this.systems.find(s => s.number == systemNumber);
    return system && system.name ? system.name : 'Unknown system';
  }
}
